import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class LocalStorageService {

  constructor() { }

  public addItem(key: string, value: string): void {
    if (key === 'language') {
      localStorage.setItem(key, value);
      return;
    }
    localStorage.setItem(key, JSON.stringify(value));
  }

  public getItem(key: string): any {
    const value = localStorage.getItem(key);

    if (value !== null) {
      try {
        if (key === 'language') {
          // normalize in case legacy value was stored as JSON string
          if (value.startsWith('"') && value.endsWith('"')) {
            return JSON.parse(value);
          }
          return value;
        }
        return JSON.parse(value);
      } catch (error) {
        console.error('Erro ao fazer o parse do valor JSON:', error);
        return null;
      }
    } else {
      return null;
    }
  }


  public removeItem(key: string): void {
    localStorage.removeItem(key);
  }

  public clearItems() {
    localStorage.clear();
  }

}
